// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.mercury-c-gravityHeader{position:fixed;top:0;z-index:100}`, "",{"version":3,"sources":["webpack://./src/components/templates/header/header.scss"],"names":[],"mappings":"AAAA,yBACE,cAAA,CACA,KAAA,CACA,WAAA","sourcesContent":[".mercury-c-gravityHeader {\n  position: fixed;\n  top: 0;\n  z-index: 100;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
